<script>
  import './style.scss';
  import template from './template.html';
  import axios from 'axios';
  import { CalendarCheckIcon, RhombusIcon, ChevronDownIcon, ChevronUpIcon, CloseIcon, CheckCircleIcon } from '../icons.js';
  import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
  import { getUsers } from '../Review-Request-Form/utils.js'
  import {isEmpty, toArray} from 'lodash';
  import moment from 'moment';


  export default {

    props: {

      mode: {
        default: 'full',
        type: String
      },

      fileless: {
        default: false,
        type: Boolean
      },

      reviewFiles: {
        default: function () {
          return [];
        },
        type: Array
      },

      orderId: {
        default: 0,
      }
    },

    created () {

      getUsers().then(users => {
        this.reviewers = users.filter(user => user.is_reviewer).map(user => {
          return Object.assign({}, user, { name: `${user.first_name} ${user.last_name}` })
        });
      })
    },

    computed: {

      isFullMode () {
        return this.mode == 'full';
      },

      selectedItemsCount () {
        return this.files.filter(file => file.selected).length;
      },

      minDate () {
        return moment(Date()).format('YYYY-MM-DD');
      }
    },

    methods: {

      submitTask () {
        let users = [this.task.users.id]; //map(user => user.id);
        let order_id = this.orderId;
        let files = this.files.filter(file => file.selected).map(file => file.id);
        let notes = this.task.notes;
        let due_at = this.task.due_at + ' 12:00:00'; //+ (this.task.due_time || '12:00:00');
        let params = {};

        if (!isEmpty(files)) params = { files };

        let task = Object.assign({}, this.task, { users, order_id, notes, due_at }, params);

        return axios
          .post('/review/task', task)
            .catch(function(error) {

            })
          .then(result => {
            this.formSubmitted = true;
            this.reviewers = [this.task.users.name];
            this.task = task;
            this.$emit('task-created');
          });
      },

      toggleAllFiles () {
        //@TODO - why is there a delay with the result??
        setTimeout(() => {
          for (let i = 0; i < this.files.length; i++) {
            this.$set(this.files, i, Object.assign({}, this.files[i], {selected: this.allFilesSelected}));
          }
        }, 100)
      },

      setReviewFiles (orderId) {
        axios({
          url: `/review/files/${orderId}`,

          transformResponse: [(data) => {
            return {data: toArray(JSON.parse(data).data)};
          }]
        }).then((result) => {
          this.files = result.data.data || [];
        })
      }
    },

    mounted () {

      if (!this.reviewFiles.length && this.orderId !== 0 && !this.fileless) {
        this.setReviewFiles(this.orderId);
      }
    },

    template,

    data () {

      return {
        reviewers: [],

        files: this.reviewFiles || [],

        isActive: false,

        formSubmitted: false,

        allFilesSelected: false,

        task: {
          notes: '',
          due_at: '',
          //due_time: ''
        },

        editorOptions: {
          usageStatistics: false,
          hideModeSwitch: true,
          toolbarItems: [
            'heading',
            'bold',
            'italic',
            'strike',
            'divider',
            'link',
          ]
        },

        toggles: {
          accordianOpen: false,
        }
      }
    },

    components: {
      CalendarCheckIcon
      ,RhombusIcon
      ,ChevronDownIcon
      ,ChevronUpIcon
      ,ValidationProvider
      ,ValidationObserver
      ,CloseIcon
      ,CheckCircleIcon
    }
  };
</script>
